export default __webpack_public_path__ + "static/media/position-unknown.49dd0bf3.svg";